<div class="margin-bottom">
  <app-pratica-title></app-pratica-title>



  <div class="flex score-cards-container justify-between flex-wrap">

    <!--SCORE CARDS-->
    <div style="margin: 15px 15px 0 0">

      <mat-card>
        <mat-card-content>
          <div class="flex sx-card-content justify-between items-center">
            <div class="mid">Fascia Crescitalia Score</div>
            <div class="circle flex">
              <span class="text">{{(kpi | async)?.Fascia}}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="margin">
        <mat-card-content>
          <div class="flex sx-card-content justify-between items-center">
            <div class="mid">Score CRIF</div>
            <div class="circle flex">
              <span class="text">{{(productService.analisiCreditoProduct$ | async)?.score?.class}}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="margin">
        <mat-card-content>
          <div class="flex sx-card-content justify-between items-center">
            <div class="mid">Punteggio Crescitalia Score</div>
            <div class="circle flex">
              <span class="text">{{(kpi | async)?.Score}}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!--MODULI INFO CARD -->
    <div class="dx-column bg-primary-50 info-card flex flex-col justify-around flex-1 left-card"
      style="margin-top: 15px;">

      <div *ngFor="let modulo of moduli$ | async" class="flex justify-between">
        <div class="flex" style="gap: 0.5rem;">
          <p class="light">{{modulo.title | label}}</p>
          <div class="small-circle" [ngClass]="modulo.outcomeCssClass"></div>
          <mat-icon *ngIf="modulo.hasWarning" class="warning-text">warning</mat-icon>
          <mat-icon *ngIf="modulo.hasError" color="warn" class="error">warning</mat-icon>
        </div>
        <div class="">
          <p class="mid">{{modulo.score}}</p>
        </div>
      </div>

    </div>
  </div>

  <div class="flex justify-between product-cards-container" style="margin-top: 15px;">

    <!--PRODUCT CARD-->
    <div class="bg-primary-50 info-card left-card flex-1">
      <h2>Prodotto</h2>
      <div class="flex space-between" style="margin-bottom: 1rem;">
        <div style="flex: 1.3">
          <div class="light small">Nome prodotto</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ | async)?.tipoProdotto}}</div>
        </div>

        <div style="flex: 1">
          <div class="light small">Durata</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ | async)?.data?.['durata'] ?
            (productService.analisiCreditoProduct$ | async)?.data?.['durata'] + ' MESI' : ''}}</div>
        </div>

      </div>

      <div class="flex space-between" style="margin-bottom: 1rem;">
        <div style="flex: 1.3">
          <div class="light small">Importo</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ | async)?.importoDeliberato ||
            (productService.analisiCreditoProduct$ | async)?.importo |
            currency:'EUR':'symbol':'1.2-2':'it'}}</div>
        </div>

        <div style="flex: 1">
          <div class="light small">Pre-ammortamento</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ | async)?.data?.['preammortamento'] ?
            (productService.analisiCreditoProduct$ | async)?.data?.['preammortamento'] + ' MESI' : ''}}</div>
        </div>

      </div>

      <div class="flex space-between" style="margin-bottom: 1rem;">
        <div style="flex: 1.3">
          <div class="light small">Finalità</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ | async)?.data?.['finalita']}}</div>
        </div>

        <div style="flex: 1">
          <div class="light small">% Garanzia Confidi</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ | async)?.data?.['garanzieConfidi'] ?
            (productService.analisiCreditoProduct$ | async)?.data?.['garanzieConfidi'] + '%' : '' }}</div>
        </div>

      </div>



    </div>

    <!--COMMISSIONI CARD-->
    <div class="bg-primary-50 info-card right-card flex-1">
      <h2>Condizioni economiche</h2>
      <div class="flex space-between" style="margin-bottom: 1rem;">
        <div style="flex: 1">
          <div class="light small">Commissioni di mediazione</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ |
            async)?.pricing?.Totale_Commissioni_Mediazione_e_canale_percentuale ?
            (productService.analisiCreditoProduct$ | async)?.pricing?.Totale_Commissioni_Mediazione_e_canale_percentuale
            + '%' : '0' }}
          </div>
        </div>

        <div style="flex: 1">
          <div class="light small">Commissioni di erogazione</div>
          <div class="mid">{{(productService.analisiCreditoProduct$ | async)?.pricing?.Costo_Erogazione_Perc ?
            (productService.analisiCreditoProduct$ | async)?.pricing?.Costo_Erogazione_Perc + '%' : '0' }}</div>
        </div>

      </div>
      <div class="flex space-between" style="margin-bottom: 1rem;">

        <div style="flex: 1">
          <div class="light small">Costo garanzia</div>
          <div class="mid">{{(kpi | async)?.Costo_Garanzia ?
            (kpi | async)?.Costo_Garanzia + '%' : '0' }}</div>
        </div>

        <div style="flex: 1">
          <div class="light small">TAN</div>
          <div class="mid">{{(kpi | async)?.TAN ?
            (kpi | async)?.TAN + '%' : '0' }}</div>
        </div>

      </div>

      <div class="flex space-between" style="margin-bottom: 1rem;">

        <div style="flex: 1">
          <div class="light small">Spread</div>
          <div class="mid">{{(kpi | async)?.Spread ?
            (kpi | async)?.Spread + '%' : '0' }}</div>
        </div>

        <div style="flex: 1">
          <div class="light small">Parametro (Euribor)</div>
          <div class="mid">{{(kpi | async)?.Euribor ?
            (kpi | async)?.Euribor + '%' : '0' }}</div>
        </div>

      </div>
    </div>
  </div>